import { Event } from '@mirai/data-sources';
import { useLocale } from '@mirai/locale';
import { Button, Icon, Pressable, styles, Text, useDevice, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { L10N } from './Rating.l10n';
import * as style from './Rating.module.css';
import { EVENT, ICON, METRICS_EVENTS } from '../../../helpers';

const STARS = [1, 2, 3, 4, 5];

const Rating = ({ onRejoin = () => {}, onReturnHome = () => {} }) => {
  const { isMobile } = useDevice();
  const { translate } = useLocale();

  const [value, setValue] = useState(undefined);

  const handleRate = (next) => {
    setValue(next);
    Event.publish(EVENT.METRICS, { id: METRICS_EVENTS.CONVERSATION_RATING, rating: next });
    onReturnHome();
  };

  return (
    <View wide className={style.container}>
      <Text brand medium headline level={1}>
        {translate(L10N.LABEL_LEFT_CONVERSATION)}
      </Text>

      <View align="center" row className={style.actions}>
        <Button large secondary onPress={onRejoin}>
          {translate(L10N.ACTION_REJOIN)}
        </Button>
        <Button large onPress={onReturnHome}>
          {translate(L10N.ACTION_RETURN_HOME)}
        </Button>
      </View>

      <View className={style.card}>
        <Text medium headline level={3}>
          {translate(L10N.LABEL_HOW_WAS_CONVERSATION)}
        </Text>

        <View row className={style.stars}>
          {STARS.map((option, index) => (
            <View key={`rating:${option}`} className={style.starContainer}>
              <Pressable onEnter={() => setValue(index)} onLeave={() => setValue()} onPress={() => handleRate(option)}>
                <Icon
                  light
                  value={ICON[207]}
                  headline
                  level={1}
                  className={styles(style.star, index <= value && style.active)}
                />
              </Pressable>

              {index === 0 && (
                <Text light small={!isMobile} tiny={isMobile}>
                  {translate(L10N.LABEL_VERY_BAD)}
                </Text>
              )}
              {index === STARS.length - 1 && (
                <Text light small={!isMobile} tiny={isMobile}>
                  {translate(L10N.LABEL_VERY_GOOD)}
                </Text>
              )}
            </View>
          ))}
        </View>
      </View>
    </View>
  );
};

Rating.displayName = 'Mirai:Core:Chat.Rating';

Rating.propTypes = {
  onRate: PropTypes.func,
  onRejoin: PropTypes.func,
  onReturnHome: PropTypes.func,
};

export { Rating };
